<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import AdminForm from '@/components/admin/AdminForm.vue'
import AdminRoleForm from '@/components/admin/role/AdminRoleForm.vue'
import { AloDbRole } from '@/models/alodb/AloDbRole'
import { SecurityItemsKeys } from '@/enum/SecurityItems'


@Component({
  name: 'AdminRole',
  components: {AdminRoleForm}
})
export default class AdminRole extends AdminForm<AloDbRole> {  

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_ROLE].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }
  
  get itemTypeName() {
    return "Role"
  }

  get originalLibelle() {
    return this.original.ROL_LIBELLE
  }

}
</script>